// crear plantilla defualt 
import * as XLSX from 'xlsx'

export default {
    name: 'seguimiento_declaracion',
    data() {
        return {
            listaUsuarios: [],
            cargando: false,
            buscar: "",
            userSelected: null,
            menu1: false,
            dateFormatted: null,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateUnformatted: null,
            campoRules: [
                v => !!v || 'El campo es requerido',
            ],
            seguimientoItems: [
            ],
            headersSeguimiento: [
                {
                    text: 'Paso', value: 'estado_seguimiento', sortable: true
                },
                { text: 'Ingr. por venta de bienes y/o prestación de servicios', value: 'total_facturas', sortable: true },
                { text: 'Valor de retenciones', value: 'total_retencion', sortable: true },
                { text: 'Impuesto a pagar', value: 'impuesto', sortable: true },
                { text: 'Mes', value: 'mes_presentacion', sortable: true },
                { text: 'Estado', value: 'activo', sortable: true },
                { text: 'Fecha', value: 'fecha_realizado', sortable: true },
                { text: 'Detalle', value: 'detalle', sortable: false },
            ],
            retenciones: [],
            facturas: [],
            facturas_recibidas: [],
            dialogResumenPC: false,

            item_aux: {},
            copyText: '',
            text: "Copiar",

            loading_screen: false,
        };
    },

    async created() {
        console.log("seguimiento de declaraciones");
        await this.listadoUsuarios();
    },

    methods: {

        async descargarBoleta() {
            console.log('descargarBoleta', this.item_aux, this.userSelected);
            this.loading_screen = true;


            try {

                let fecha = this.item_aux.fecha_realizado;

                let mes = fecha.split('-')[1];
                let anio = fecha.split('-')[0];

                let usuario_id = this.userSelected.usuario_id;
                let body = {
                    usuario: usuario_id,
                    mes_transaccion: mes,
                    anio_transaccion: anio
                };

                let r = await this.$store.state.services.reportesService.buscarDocumentosSat(body);
                console.log('r', r);
                // este responde un array de pdfs debes buscar esta propiedad base64
                if (r.data.data.length > 0 && typeof (r.data.data) !== 'string') {
                    for (let i = 0; i < r.data.data.length; i++) {
                        setTimeout(() => {
                            let base64 = r.data.data[i].base64;
                            let nombre = r.data.data[i].file_name;
                            let link = document.createElement('a');
                            link.href = `data:application/pdf;base64,${base64}`;
                            link.download = nombre;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }, i * 1000);
                    }


                    console.log('Documentos descargados correctamente');
                    this.$toast.success('Documentos descargados correctamente', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                } else {
                    this.$toast.info('No se encontraron documentos para descargar', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                }


            } catch (error) {

                console.log(error, 'error al descargar la boleta');
            } finally {
                this.loading_screen = false;
            }
        },

        convertirnumero(numero) {
            let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
            return dollarUSLocale.format(Math.abs(parseFloat(numero).toFixed(2)));
        },

        reset() {
            console.log("reset");
            this.copyText = this.text
        },

        getColorForMonth(mes) {
            const monthColors = {
                'Enero': 'orange',
                'Febrero': 'blue',
                'Marzo': 'green',
                'Abril': 'yellow',
                'Mayo': 'purple',
                'Junio': 'teal',
                'Julio': 'pink',
                'Agosto': 'brown',
                'Septiembre': 'cyan',
                'Octubre': 'lime',
                'Noviembre': 'amber',
                'Diciembre': 'indigo'
            };
            return monthColors[mes] || 'grey'; // Default color if month is not found
        },

        generaAnios() {
            let anios = [];
            let anioActual = new Date().getFullYear();
            for (let i = 0; i < 5; i++) {
                anios.push(anioActual - i);
            }
            return anios;
        },

        customFilter(item, queryText) {
            const nit = item.usuario.nit ? item.usuario.nit.toString().toLowerCase() : '';
            const cui = item.usuario.cui ? item.usuario.cui.toString().toLowerCase() : '';
            const primerNombre = item.usuario.primer_nombre ? item.usuario.primer_nombre.toLowerCase() : '';
            const segundoNombre = item.usuario.segundo_nombre ? item.usuario.segundo_nombre.toLowerCase() : '';
            const primerApellido = item.usuario.primer_apellido ? item.usuario.primer_apellido.toLowerCase() : '';
            const segundoApellido = item.usuario.segundo_apellido ? item.usuario.segundo_apellido.toLowerCase() : '';
            const nombreCompleto = `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim();
            const query = queryText.toLowerCase();

            return (
                nit.includes(query) ||
                cui.includes(query) ||
                nombreCompleto.includes(query)
            );
        },

        async listadoUsuarios() {
            try {
                this.cargando = true;
                let r = await this.$store.state.services.gestoresService.listadoUsuarios();
                console.log(r);
                if (r.data.data != null) {
                    this.listaUsuarios = r.data.data;
                }
            } catch (error) {
                console.log(error);
                this.$toast.info("Error al cargar los usuarios del gestor");
            } finally {
                this.cargando = false;
            }
        },

        formatDate(date) {
            console.log("formatDate", date);
            if (!date) return null

            const [year, month] = date.split('-')
            return `${month}/${year}`
        },

        async buscarInfoUsuario() {
            if (this.$refs.seguimientoForm.validate()) {
                console.log("buscarInfoUsuario");
                console.log(this.userSelected);
                console.log(this.dateFormatted);
                let body = {
                    id: this.userSelected.id,
                    anio: this.dateFormatted
                };
                console.log(body);
                this.seguimientoPresentacionGestor(body);
            }
        },

        async seguimientoPresentacionGestor(body) {
            try {
                this.cargando = true;
                let r = await this.$store.state.services.gestoresService.seguimientoPresentacionGestor(body);
                console.log(r);
                if (r.data.data != null) {
                    this.seguimientoItems = r.data.data;
                }
            } catch (error) {
                console.log(error);
                this.$toast.info("El usuario no tiene declaraciones en este mes",
                    { position: 'bottom-center', duration: 5000 });

            } finally {
                this.cargando = false;
            }
        },

        async getPresentarFacturas(presentacion_id) {
            console.log("facturas asociadas a la  presentacion");
            try {
                this.cargando = true;
                let r = await this.$store.state.services.presentacionService.getPresentarFacturas(presentacion_id);
                console.log("getPresentarFacturas.r:", r);
                this.facturas = r.data.data;
            } catch (error) {
                console.log(error);
                this.$toast.error(
                    "Ocurrió un error al obtener los datos de las declaraciones"
                );
            } finally {
                this.cargando = false;
            }
        },

        async getPresentarRetenciones(presentacion_id) {
            console.log("retenciones asociadas a la  presentacion");
            try {
                this.cargando = true;
                let r = await this.$store.state.services.presentacionService.getPresentarRetenciones(presentacion_id);
                console.log("getPresentarRetenciones.r:", r);
                this.retenciones = r.data.data;
            } catch (error) {
                this.$toast.error(
                    "Ocurrió un error al obtener los datos de las declaraciones "
                );
            } finally {
                this.cargando = false;
            }
        },

        async detallePresentacion(item) {
            console.log("detallePresentacion", item);
            this.item_aux = {
                primer_nombre: this.userSelected.usuario.primer_nombre,
                segundo_nombre: this.userSelected.usuario.segundo_nombre,
                primer_apellido: this.userSelected.usuario.primer_apellido,
                segundo_apellido: this.userSelected.usuario.segundo_apellido,
                cui: this.userSelected.usuario.cui,
                nit: this.userSelected.usuario.nit,
                impuesto: item.impuesto,
                mes_presentacion: item.mes_presentacion,
                total_facturas: item.total_facturas,
                total_retencion: item.total_retencion,
                fecha_realizado: item.fecha_realizado,
                fecha_presentacion: item.fecha_presentacion,

            };
            await this.getPresentarFacturas(item.presentacion_impuesto_id);
            await this.getPresentarRetenciones(item.presentacion_impuesto_id);
            await this.postlibrosCompras();
            this.dialogResumenPC = true;
        },

        async copyCode(data) {
            await navigator.clipboard.writeText(data);
            this.copyText = "Copiado"
        },

        async descargarLibroComprasVentas() {
            console.log('descargarLibroComprasVentas', this.item_aux, this.userSelected);
            this.loading_screen = true;

            try {
                let fecha = this.item_aux.fecha_presentacion;
                let mes = fecha.split('-')[1];
                let anio = fecha.split('-')[0];

                let usuario_id = this.userSelected.usuario_id;
                let body = {
                    usuario_id: usuario_id,
                    mes: mes,
                    anio: anio
                };

                let r = await this.$store.state.services.reportesService.descargarLibroComprasVentas(body);
                console.log("descargarLibroComprasVentas.r:", r);
                // r.data.data contiene el PDF en base64
                if (r.data.data && typeof (r.data.data) === 'string') {



                    this.exportarExcel(1, this.facturas);

                    this.exportarExcel(2, this.facturas_recibidas);


                    setTimeout(() => {
                                            let base64 = r.data.data;
                    let nombre = `libro_compras_ventas_${usuario_id}_${mes}_${anio}.pdf`;
                    let link = document.createElement('a');
                    link.href = `data:application/pdf;base64,${base64}`;
                    link.download = nombre;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.$toast.success('Libro de compras y ventas descargado correctamente', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                }, 1000);

                }
                else {
                    this.$toast.info('No se encontraron datos para descargar', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                }
            } catch (error) {
                console.log(error);
                this.$toast.error(
                    "Ocurrió un error al descargar el libro de compras y ventas"
                );
            } finally {
                this.loading_screen = false;
            }
        },

        exportarExcel(tipo, items) {
            // si items no tiene datos, no se puede exportar
            if (items.length === 0) {
                return;
            }

            console.log("exportarExcel", tipo);
            let data = XLSX.utils.json_to_sheet(items)
            const workbook = XLSX.utils.book_new()
            let filename = ''
            if (tipo == 1) {
                filename = 'facturas_emitidas' + this.item_aux.nit;
            } else if (tipo == 2) {
                filename = 'facturas_recibidas' + this.item_aux.nit;
            }
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        },

        async postlibrosCompras() {
            console.log("postlibrosCompras", this.item_aux, this.userSelected);
            // fecha solo mm/yyyy y usuario_id
            this.cargando = true;
            let fecha = this.item_aux.fecha_presentacion;
            let mes = fecha.split('-')[1];
            let anio = fecha.split('-')[0];
            let usuario_id = this.userSelected.usuario_id;
            let body = {
                usuario_id: usuario_id,
                fecha: `${mes}/${anio}`
            };

            try {
                let r = await this.$store.state.services.presentacionService.postlibrosCompras(body);
                console.log("libros de compras");
                console.log(r);
                this.facturas_recibidas = r.data.data.facturas;
            } catch (error) {
                console.log(error);
                this.$toast.info(
                    "No se encontraron coincidencias"
                );
            } finally {
                this.cargando = false;
            }
        },

        descargarRetenciones() {
            console.log('descargarRetenciones', this.retenciones);
            this.loading_screen = true;

            try {
                if (this.retenciones.length > 0) {
                    let data = XLSX.utils.json_to_sheet(this.retenciones);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, data, 'Retenciones');
                    XLSX.writeFile(workbook, `retenciones_${this.userSelected.usuario_id}.xlsx`);
                    this.$toast.success('Retenciones descargadas correctamente', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                } else {
                    this.$toast.info('No hay retenciones para descargar', {
                        timeout: 3000,
                        position: 'top-right'
                    });
                }
            } catch (error) {
                console.error('Error al descargar las retenciones:', error);
                this.$toast.error('Error al descargar las retenciones', {
                    timeout: 3000,
                    position: 'top-right'
                });
            } finally {
                this.loading_screen = false;
            }
        },

    },

    watch: {
        date: function (val) {
            this.dateUnformatted = val;
            this.dateFormatted = this.formatDate(val);
        }
    },

    computed: {
    }

};